/**
 * AI 分析 - 关键成功因素
 */
import React from 'react';
import { Card, Space, Typography, Tag } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

interface SuccessFactor {
  factor: string;
  description: string;
  importance: string;
}

interface AISuccessFactorsProps {
  successFactors: SuccessFactor[];
}

export const AISuccessFactors: React.FC<AISuccessFactorsProps> = ({ successFactors }) => {
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case '高':
        return 'red';
      case '中':
        return 'orange';
      case '低':
        return 'green';
      default:
        return 'default';
    }
  };

  return (
    <Card
      title={
        <Space>
          <TrophyOutlined style={{ color: '#faad14' }} />
          关键成功因素
        </Space>
      }
      className="ai-content-card"
    >
      {successFactors.map((factor, index) => (
        <div key={index} className="success-factor-item">
          <div className="success-factor-header">
            <Tag color={getSeverityColor(factor.importance)}>{factor.importance}重要</Tag>
            <span className="success-factor-title">{factor.factor}</span>
          </div>
          <Paragraph className="success-factor-description">{factor.description}</Paragraph>
        </div>
      ))}
    </Card>
  );
};

